/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from 'react'
import Modal from 'react-bootstrap/Modal';
import {TfiClose} from 'react-icons/tfi'




interface ResetPasswordProps {
    show: boolean;
    onHide: () => void;
    title: string;
    message: string;
    onConfirm: () => void;
    buttonName?: string;
  }


const ResetPassword: React.FC<ResetPasswordProps> = ({
    show,
    onHide,
    title,
    message,
    onConfirm,
    buttonName
}) => {
  return (
    <Modal centered lassName='customModal-alert-expiry' show={show}>
        <div>
        <div className='modalHead'>
            <p className='modalHeadText2 mx-3 my-2'>{title}</p>
            <div onClick={onHide} className='p-2 mx-2'>
            <TfiClose fill="#FFFFFF" />
            </div>
        </div>
        <div className='text-center mt-3 mb-5'>
            <p className='normalText2 '><br/> 
                <span><strong>{message}</strong></span>
            </p>
        </div>
        <div className='d-flex justify-content-around pb-3'>
            <button onClick={onHide} className='modalCancelBtn2'>
            {buttonName === 'Reset' ? 'Login' : 'Cancel'}
            </button>
            <button onClick={onConfirm} className='squareOrangeBtn3'>
            {buttonName ? buttonName : "Reset"}
            </button>
        </div>
        </div>
    </Modal>
  )
}

export default ResetPassword